export default __webpack_public_path__ + "static/transferLogo-4b7d7a6dc40960d6964a43ec870bf0af.png";